import { AuthService } from '../../utils/authService'
import ApiService from '../../utils/apiService'
import {jwtDecode} from 'jwt-decode'

let pendingUserInfoRequest = null;

const state = {
  email: '',
  user_name: '',
  organization:'',
  idToken: '',
  token: '',
  role: '',
  allRoles: [],
  displayRoles: {
    'Internal-adm': 'AH Admin',
    'Internal-ReadOnly': 'AH Read Only',
    'Internal-usr': 'AH User', // support role
    'MaintenanceCenter-adm': 'Maintenance Center Admin',
    'MaintenanceCenter-usr': 'Maintenance Center User',
    'Customer-adm': 'Admin',
    'Customer-usr': 'User'
  }
}

const actions = {
  loadToken ({ commit }) {
    return new Promise( async function (resolve, reject) {
      AuthService.getAccessToken().then((token) => {
        commit('setToken', token.toString())
        //console.log('setToken', token.toString())
        resolve(true)
      })
    })
  },
  loadTokenId ({ commit }, idToken) {
    return new Promise( async function (resolve, reject) {
      AuthService.getIdToken().then((idtoken) => {
        commit('setTokenId', idtoken.toString())
        resolve(true)
      })
    })
  },
  loadRenewedTokenId ({ commit }, idToken) {
    return new Promise( async function (resolve, reject) {
      AuthService.getIdToken().then((idtoken) => {
        commit('setTokenId', idtoken.toString())
        //console.log('setTokenId', idtoken.toString())
        resolve(true)
      })
    })
  },
  loadUserInfo ({ commit, state, getters }) {
    if (getters.hasUserInfo) {
      return Promise.resolve(true);
    }

    if (pendingUserInfoRequest) {
      return pendingUserInfoRequest;
    }

    pendingUserInfoRequest = (async () => {
      let email = 'Unknown Email';
      let userName = 'Unknown User';

      try {
        if (!state.idToken) {
          throw new Error("No token provided");
        }

        let decryptedToken;
        try {
          decryptedToken = jwtDecode(state.idToken);
        } catch (decodeError) {
          throw new Error("Invalid token format");
        }

        email = decryptedToken['email'] || 'Unknown Email';
        userName = getUserName(decryptedToken)
        
        const userRoles = getRoles(decryptedToken);
        if (!userRoles || userRoles.length === 0) {
          alert(`No DFM roles were found for your account.\nUser: ${userName}\nEmail: ${email}`);
          throw new Error("No valid roles found in token");
        }

        const response = await ApiService.get('/user_info');
        
        if (!response.data) {
          throw new Error("API returned empty user data");
        }

        commit('setEmail', response.data['email']);
        commit('setOrganization', response.data['organization_name']);
        commit('setUsername', response.data['username']);
        commit('setRole', response.data['main_role']);
        commit('setAllRoles', response.data['all_roles']);

        
        return true;

      } catch (error) {
        console.error("Failed to load user info:", error.message || error);

        AuthService.signOut();
        
        throw error; 

      } finally {
        pendingUserInfoRequest = null;
      }
    })();

    return pendingUserInfoRequest;
  },
  logOut ({commit}) {
    return new Promise( async function (resolve, reject) {
      commit('clearUserInfo')
      commit('setTokenId', '')
      commit('setToken', '')
      sessionStorage.removeItem('roleAlertDismissed')
      resolve(true)
    })
  }
}

const getters = {
  // Also related to these functions: src/components/navigations/TheSidebar.vue (setNavigationItems)
  isAdmin: state => {
    // "isAdmin" needs to be renamed to something more appropriate now that Internal-usr has been added.
    return ['Internal-adm', 'MaintenanceCenter-adm', 'Customer-adm', 'Internal-usr'].includes(state.role)
  },
  isAHAdmin: state => {
    return state.role === 'Internal-adm' 
  },
  canFilter: state => {
    return state.role !== 'Customer-adm' && state.role !== 'Customer-usr'
  },
  canSeeSimUsage: state => {
    return ['Internal-adm', 'Customer-adm', 'Internal-ReadOnly', 'Internal-usr'].includes(state.role)
  },
  hasUserInfo: state => {
    return state.role && state.user_name
  }
}

const mutations = {
  setTokenId (state, newToken) {
    state.idToken = newToken
  },
  setRole (state, newRole) {
    state.role = newRole
  },
  setToken (state, newToken) {
    state.token = newToken
  },
  setEmail (state, newEmail) {
    state.email = newEmail
  },
  setOrganization (state, new_organization) {
    state.organization = new_organization
  },
  setUsername (state, newUserName) {
    state.user_name = newUserName
  },
  setAllRoles (state, newRoles) {
    state.allRoles = newRoles
  },
  clearUserInfo (state) {
    state.role = ''
    state.email = ''
    state.organization = ''
    state.user_name = ''
    state.allRoles = []
  }
}

function getRoles (decryptedToken) {
  const token_roles = decryptedToken['custom:memberOf']
  if (token_roles != null) {
    const roles = token_roles.split(',')
    var userRoles = []
    roles.forEach(role => {
      if (role.includes('GIRE')) {
        const roleRegexp = /usr-([\w\d-]*)/gm
        const match = roleRegexp.exec(role)
        if (match && match[1]) {
          if (!userRoles.includes(match[1])) {
            userRoles.push(match[1])
          }
        }
      }
    })
    return userRoles
  }
  return []
}

function getUserName(decryptedToken) {
  let userName = decryptedToken['cognito:username'] || 'Unknown User'
  var res = userName.split('_')[1]
  if (res == null) {
    res = userName
  }

  return res
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
